import { render, staticRenderFns } from "./SelfJuge.vue?vue&type=template&id=4073bb29&"
import script from "./SelfJuge.vue?vue&type=script&lang=js&"
export * from "./SelfJuge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports